import React from "react";
import { DetailSidebarType } from "@src/features/sidebars/detailSidebar";
import HrisEmployeeSidebar from "@src/features/settings/hris/HrisEmployeeDetailSidebar";
import HrisEmployeeEventDetailSidebar from "@src/features/settings/hris/HrisEmployeeEventDetailSidebar";
import HrisIntegrationDetailSidebar from "@src/features/settings/hris/HrisIntegrationDetailSidebar";
import HrisLocationSidebar from "@src/features/settings/hris/HrisLocationDetailSidebar";
import HrisRoleDetailSidebar from "@src/features/settings/hris/HrisRoleDetailSidebar";
import HrisSyncSidebar from "@src/features/settings/hris/HrisSyncDetailSidebar";
import OrgSftpIntegrationDetailSidebar from "@src/features/settings/hris/OrgSftpIntegrationDetailSidebar";
import HrisCsvUploadDetailSidebar from "@src/features/settings/hris/HrisCsvUploadDetailSidebar";
import RemoteHrisSftpCsvDetailSidebar from "@src/features/settings/hris/RemoteHrisSftpCsvDetailSidebar";
import TraineeLibraryItemDetailSidebar from "@src/features/myTraining/TraineeLibraryItemDetailSidebar";
import NewStoreOpeningsListSidebar from "@src/features/reporting/widgets/results/NewStoreOpeningsListSidebar";
import GuestFeedbackIntegrationDetailSidebar from "@src/features/guestFeedback/GuestFeedbackIntegrationDetailSidebar";
import GuestFeedbackSyncDetailSidebar from "@src/features/guestFeedback/GuestFeedbackSyncDetailSidebar";
import GuestFeedbackCsvUploadDetailSidebar from "@src/features/guestFeedback/GuestFeedbackCsvUploadDetailSidebar";

type DetailSidebarRendererProps = {
  sidebarType: DetailSidebarType;
  objectId: string;
  showHeader?: boolean;
};

export const DetailSidebarRenderer: React.FC<DetailSidebarRendererProps> = ({
  sidebarType,
  objectId,
  showHeader = true,
}) => {
  switch (sidebarType) {
    case DetailSidebarType.HrisEmployee:
      return (
        <HrisEmployeeSidebar rowId={Number(objectId)} showHeader={showHeader} />
      );

    case DetailSidebarType.HrisEmployeeEvent: {
      // objectId format: "pghId:hrisEmployeeId" or just "pghId"
      const [pghId, hrisEmployeeId] = objectId.includes(":")
        ? objectId.split(":").map(Number)
        : [Number(objectId), undefined];
      return (
        <HrisEmployeeEventDetailSidebar
          rowId={pghId}
          hrisEmployeeId={hrisEmployeeId}
          showHeader={showHeader}
        />
      );
    }

    case DetailSidebarType.HrisIntegration:
      return (
        <HrisIntegrationDetailSidebar
          rowId={objectId}
          showHeader={showHeader}
        />
      );

    case DetailSidebarType.HrisLocation:
      return (
        <HrisLocationSidebar rowId={Number(objectId)} showHeader={showHeader} />
      );

    case DetailSidebarType.HrisRole:
      return (
        <HrisRoleDetailSidebar
          rowId={Number(objectId)}
          showHeader={showHeader}
        />
      );

    case DetailSidebarType.HrisSync:
      return (
        <HrisSyncSidebar rowId={Number(objectId)} showHeader={showHeader} />
      );

    case DetailSidebarType.OrgSftpIntegration:
      return (
        <OrgSftpIntegrationDetailSidebar
          rowId={objectId}
          showHeader={showHeader}
        />
      );

    case DetailSidebarType.HrisCsvUpload:
      return (
        <HrisCsvUploadDetailSidebar rowId={objectId} showHeader={showHeader} />
      );

    case DetailSidebarType.RemoteHrisSftpCsv:
      return (
        <RemoteHrisSftpCsvDetailSidebar
          rowId={objectId}
          showHeader={showHeader}
        />
      );

    case DetailSidebarType.TraineeLibraryItem:
      return (
        <TraineeLibraryItemDetailSidebar
          rowId={objectId}
          showHeader={showHeader}
        />
      );

    case DetailSidebarType.NewStoreOpeningsList:
      return <NewStoreOpeningsListSidebar showHeader={showHeader} />;

    case DetailSidebarType.GuestFeedbackIntegration:
      return (
        <GuestFeedbackIntegrationDetailSidebar
          rowId={objectId}
          showHeader={showHeader}
        />
      );

    case DetailSidebarType.GuestFeedbackSync:
      return (
        <GuestFeedbackSyncDetailSidebar
          rowId={objectId}
          showHeader={showHeader}
        />
      );

    case DetailSidebarType.GuestFeedbackCsvUpload:
      return (
        <GuestFeedbackCsvUploadDetailSidebar
          rowId={objectId}
          showHeader={showHeader}
        />
      );

    default:
      return (
        <div className="flex h-full items-center justify-center">
          <div className="space-y-2 text-center">
            <div className="text-sm text-muted-foreground">
              Unknown sidebar type: {sidebarType}
            </div>
          </div>
        </div>
      );
  }
};
